import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20flat%20lay%20of%20sneakers%2C%20hoodies%2C%20caps%2C%20backpacks%20and%20accessories%20neatly%20arranged%20on%20a%20soft%20cream%20pastel%20background%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20warm%20neutral%20tones%2C%20high%20detail%20harmonious%20composition&width=1600&height=900&seq=hero-allchinabuy-01&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product finds"
          title="AllChinaBuy Spreadsheet product finds"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur border border-background-50/20 px-4 py-1.5 text-sm font-medium text-background-100 whitespace-nowrap">
            <span className="flex w-4 h-4 items-center justify-center">
              <i className="ri-shield-check-line text-sm"></i>
            </span>
            {t('hero.badge')}
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-background-50 leading-tight">
            {t('hero.title')}
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-100 leading-relaxed">
            {t('hero.subtitle')}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaPrimary')}
              <span className="flex w-4 h-4 items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm md:text-base font-semibold text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaSecondary')}
              <span className="flex w-4 h-4 items-center justify-center">
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </span>
            </a>
          </div>

          <div className="mt-8 flex items-center gap-2 text-sm text-background-100">
            <span className="flex w-4 h-4 items-center justify-center">
              <i className="ri-verified-badge-line text-sm"></i>
            </span>
            {t('hero.trustLine')}
          </div>
        </div>
      </div>
    </section>
  );
}